<h2 mat-dialog-title>Dados do atendimento - {{ data.param.encounter.name }} teste</h2>

<mat-dialog-content class="mat-typography">
  <div *ngIf="encounter">
    <div *ngIf="!isByOrder">
      <b> {{ encounter.type }}:</b> {{ encounter?.name ? encounter?.name : 'Atendimento' }} <span *ngIf="organization">{{ organization.name }}</span>
      <br />
      <b> Data e Hora:</b> {{ layout.dateTimeFormat(encounter.startDate) }}
    </div>
    <div *ngIf="isByOrder">
      <b> {{ encounter.type }}:</b> {{ encounter?.name ? encounter?.name : 'Atendimento' }} <span *ngIf="organization">{{ organization.name }}</span>
      <br />
      <b> Data e Hora:</b> {{ layout.dateFormat(encounter.startDate) }} - Atendimento por ordem de chegada a partir de
      {{ layout.plannedStartHourFormat(encounter.byOrderInfo.startServiceHour) }}
    </div>
    <b> Tipo de agendamento:</b> {{ encounter.scheduling_method }} <br />
    <b> Valor:</b> R$ {{ encounter.value }} <br />
    <b *ngIf="encounter.scheduling_method == 'CONVENIO'"> Valor a ser pago: {{ encounter.value_agreement }}</b>
  </div>
  <mat-tab-group>
    <mat-tab label="Dados do Paciente">
      <div class="info" *ngIf="encounter">
        <div class="row">
          <div class="col-md-4 col-lg-2">Nome do paciente:</div>
          <div class="col-md-8 col-lg-10">{{ patient?.name ? patient.name : '-' }}</div>
        </div>
        <div class="row">
          <div class="col-md-4 col-lg-2">Data de nascimento:</div>
          <div class="col-md-8 col-lg-10">{{ patient?.birthDate ? (patient.birthDate | mask: '00/00/0000') : '-' }}</div>
        </div>
        <div class="row">
          <div class="col-md-4 col-lg-2">CPF:</div>
          <div class="col-md-8 col-lg-10">{{ patient?.cpf ? (patient.cpf | mask: '000.000.000-00') : '-' }}</div>
        </div>
        <div class="row">
          <div class="col-md-4 col-lg-2">Telefone:</div>
          <div class="col-md-8 col-lg-10">{{ formatPhone(patient?.phone) }}</div>
        </div>
        <div class="row">
          <div class="col-md-4 col-lg-2">Genêro:</div>
          <div class="col-md-8 col-lg-10">{{ patient?.gender ? (patient.gender | translateGender) : '-' }}</div>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Informações Plano de Sáude" *ngIf="encounter.scheduling_method == 'CONVENIO'">
      <div class="info" *ngIf="encounter">
        <div class="row">
          <div class="col-md-4 col-lg-2">Nome do paciente:</div>
          <div class="col-md-8 col-lg-10">{{ encounter.health_plan.patient_name ?? '-' }}</div>
        </div>
        <div class="row">
          <div class="col-md-4 col-lg-2">Data de nascimento:</div>
          <div class="col-md-8 col-lg-10">{{ (encounter.health_plan.birth_date | mask: '00/00/0000') || '-' }}</div>
        </div>
        <div class="row">
          <div class="col-md-4 col-lg-2">Convênio:</div>
          <div class="col-md-8 col-lg-10">{{ encounter.health_plan.health_plan_name }}</div>
        </div>
        <div class="row">
          <div class="col-md-4 col-lg-2">Modalidade:</div>
          <div class="col-md-8 col-lg-10">{{ encounter.health_plan.agreement }}</div>
        </div>
        <div class="row">
          <div class="col-md-4 col-lg-2">Número Cartão:</div>
          <div class="col-md-8 col-lg-10">{{ encounter.health_plan.card_number }}</div>
        </div>
      </div>
      <page-map-view *ngIf="patient?.address" [latLong]="this.latLong" [address]="patient.address"></page-map-view>
    </mat-tab>
    <mat-tab label="Reagendamento" *ngIf="encounter.status == 'planned'">
      <div class="row rowTime">
        <div class="col-xs-12 col-sm-6 col-md-3">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Escolha a data</mat-label>

            <input
              matInput
              [matDatepickerFilter]="dateFilter"
              [matDatepicker]="picker"
              [(ngModel)]="hour.date"
              readonly
              (dateChange)="onDateChange($event)"
            />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker [dateClass]="dateClass" #picker></mat-datepicker>
          </mat-form-field>
        </div>
        <div *ngIf="isByOrder" class="col-md-4"><page-alert [message]="textForProcedureByOrder()"></page-alert></div>
        <div class="col-xs-12 col-sm-6 col-md-3" *ngIf="!isByOrder">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Horários disponíveis</mat-label>
            <mat-select [(value)]="hour.time">
              <mat-option
                *ngFor="let item of hours"
                [value]="item.timeStart"
                [disabled]="(disabledTimes && disabledTimes.includes(item.timeStart)) || hours.length == 0 || disabledMinuts(item.timeStart)"
              >
                {{ item.timeStart }} - {{ item.timeEnd }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-4">
          <button *ngIf="isByOrder" mat-flat-button color="primary" (click)="reagendamento()" [disabled]="loading || !hour.date" class="btReagendar">
            Reagendar
          </button>
          <button *ngIf="!isByOrder" mat-flat-button color="primary" (click)="reagendamento()" [disabled]="loading || !hour.time" class="btReagendar">
            Reagendar
          </button>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Comprovante de pagamento" *ngIf="paymentData?.status == 'PAID'">
      <div class="info payment-receipt" *ngIf="paymentData">
        <div class="row"><div class="col-md-4 col-lg-2">Status:</div><div class="col-md-8 col-lg-10">Pagamento confirmado</div></div>
        <div class="row"><div class="col-md-4 col-lg-2">Valor pago:</div><div class="col-md-8 col-lg-10">R$ {{ formatPaidPaymentValue(paymentData.value) }}</div></div>
        <div class="row"><div class="col-md-4 col-lg-2">Forma de pagamento:</div><div class="col-md-8 col-lg-10">{{ formatPaidPaymentMethod(paymentData) }}</div></div>
        <div class="row"><div class="col-md-4 col-lg-2">Data do pagamento:</div><div class="col-md-8 col-lg-10">{{ formatPaidPaymentDate(paymentData) }}</div></div>
        <div class="row" *ngIf="paymentData.payment_id"><div class="col-md-4 col-lg-2">Identificador:</div><div class="col-md-8 col-lg-10">{{ paymentData.payment_id }}</div></div>
        <div class="row" *ngIf="paymentData.order_id"><div class="col-md-4 col-lg-2">Pedido:</div><div class="col-md-8 col-lg-10">{{ paymentData.order_id }}</div></div>
      </div>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button *ngIf="encounter.status == 'planned'" mat-flat-button color="warn" class="btnCancelar" cdkFocusInitial (click)="cancelSchedule()">
    Cancelar atendimento
  </button>

  <button mat-button color="warn" [mat-dialog-close]="false">Fechar</button>
</mat-dialog-actions>
